$ = window.jQuery = require 'jquery'
Redirect = require '../../requires/pc/redirect'
Elements = require '../../requires/pc/views/elements'
Router = require '../../requires/pc/router'
Loader = require '../../requires/pc/views/loader'
Meta = require '../../requires/pc/views/meta'
SetPosition = require '../../requires/pc/views/set-position'
HeroBg = require '../../requires/pc/views/hero-bg'
HeroAnime = require '../../requires/pc/views/hero-anime'
Logo = require '../../requires/pc/views/logo'
Splash = require '../../requires/pc/views/splash'
Menu = require '../../requires/pc/views/menu'
Nav = require '../../requires/pc/views/nav'
OnePageScroll = require '../../requires/pc/views/one-page-scroll'
Bg = require '../../requires/pc/views/bg'
Link = require '../../requires/pc/views/link'
FirstAnime = require '../../requires/pc/views/first-anime'
WorksDetail = require '../../requires/pc/views/works-detail'
WorksList = require '../../requires/pc/views/works-list'
RecruitDetail = require '../../requires/pc/views/recruit-detail'
MailAddressCopy = require '../../requires/pc/views/mail-address-copy'
require 'html5shiv'
require 'Velocity'
require 'Velocity.ui'
require './../../vendors/velocity.easeplus'
require '../../requires/components/function-polyfill'

$ document
  .one 'ready', ->

    new Redirect
    new Elements
    new Router

    Loader.getInstance()
    Meta.getInstance()
    SetPosition.getInstance()
    HeroBg.getInstance()
    HeroAnime.getInstance()
    Logo.getInstance()
    Splash.getInstance()
    Menu.getInstance()
    Nav.getInstance()
    OnePageScroll.getInstance()
    Bg.getInstance()
    Link.getInstance()
    FirstAnime.getInstance()
    WorksList.getInstance()
    WorksDetail.getInstance()
    RecruitDetail.getInstance()
    MailAddressCopy.getInstance()



// WEBPACK FOOTER //
// ./webpack/src/scripts/index.coffee